import React from "react"
import jwt_decode from 'jwt-decode'
import { api_freedom } from "../services/apis"
import jwt from 'jsonwebtoken'
import moment from 'moment'

class ImprimirRelatorioRepassePage extends React.Component {
    constructor(props) {
        super(props)

        let data = jwt_decode(this.props.match.params.data, "PRINTER")

        this.state = {
            dados_login: jwt_decode(localStorage.getItem('autenticado_freedom')),
            servicos: data.servicos,
            dataInicio: data.datainicio,
            dataFim: data.datafim,
            mensagem: 'Carregando ....',
            loading: false,
            servicoslist: [],
            dados: [],
            inPrint: false
        }

        this.getContratos()
    }

    twoValue = (d) => {
        if (!d) return d

        if (d.length == 1) return `0${d}`

        return d
    }

    convertMesAno = (d) => {
        if (!d) return d

        let [ano, mes] = d.split("-")

        return `${mes}/${ano}`
    }

    formatarLocatarios = (locatarios) => {
        if (!locatarios || locatarios.length === 0) {
            return '---'
        }

        return locatarios.map(loc => {
            if (loc.principal) {
                return `${loc.nome} (Principal)`
            }
            return loc.nome
        }).join(', ')
    }

    getSymbolForService = (servico) => {
        const { gerar_boleto, somar_repasse, descontar_repasse, credito_debito } = servico;
if (credito_debito === 1 && gerar_boleto === 1 && somar_repasse === 1 && descontar_repasse === 0) {
    return 'P'; // Crédito Proprietário
}

if (credito_debito === 1 && gerar_boleto === 1 && somar_repasse === 0 && descontar_repasse === 0) {
    return 'I'; // Crédito Imobiliária
}

if (credito_debito === 0 && gerar_boleto === 0 && somar_repasse === 0 && descontar_repasse === 1) {
    return 'I'; // Crédito Imobiliária
}

if (credito_debito === 1 && gerar_boleto === 0 && somar_repasse === 1 && descontar_repasse === 0) {
    return 'P'; // Crédito Proprietário
}

if (credito_debito === 0 &&  gerar_boleto === 1 && somar_repasse === 0 && descontar_repasse === 0) {
    return 'L'; // Crédito Locatário
}

if (credito_debito === 0 &&  gerar_boleto === 1 && somar_repasse === 0 && descontar_repasse === 1) {
    return 'L'; // Crédito Locatário
}





        return '';
    }

    getColorForSymbol = (symbol) => {
        switch (symbol) {
            case 'P': return '#28a745';
            case 'I': return '#007bff';
            case 'L': return '#dc3545';
            default: return '#6c757d';
        }
    }

    getContratos = async () => {
        this.setState({ loading: true })

        const response = await api_freedom.post("/contrato/listbytime", {
            datainicio: this.state.dataInicio,
            datafim: this.state.dataFim,
            servicos: this.state.servicos,
            imob: this.state.dados_login.imobiliaria_id
        }, { headers: { "authorization": localStorage.getItem('autenticado_freedom') } })

        if (response.status === 200) {
            if (response.data.data.length > 0) {
                this.setState({
                    dados: response.data.data,
                    servicoslist: response.data.servicos,
                    loading: false
                })

                console.log(this.state.dados)
            } else {
                this.setState({
                    loading: false,
                    mensagem: 'Nenhum registro encontrado.'
                })
            }
        } else {
            this.setState({
                loading: false,
                mensagem: 'Nenhum registro encontrado.'
            })
        }

    }

    fotprint = () => {
        this.setState({ inPrint: true })

        setTimeout(() => {
            window.print()

            this.setState({ inPrint: false })
        }, 350);
    }
    genCSV = () => {
        let csv = 'Contrato,Nome Locatário,Ativo,Valor boleto,Vencimento boleto,Boleto Pago,';

        for (const i of this.state.servicoslist) {
            if ([2, 17].includes(i.id)) continue

            csv += i.nome + ","
        }

        csv += "Taxa de Administração,Taxa contrato,Repasse de aluguel,Competência"
        csv += "\n"

        for (const i of this.state.dados) {
            csv += `${i.contrato_id},"${this.formatarLocatarios(i.locatarios)}",${i.ativo == 1 ? "Sim" : "Não"},"${i.boleto_valor ? i.boleto_valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '---'}",`
            csv += `${i.boleto_data_vencimento ? moment(i.boleto_data_vencimento).format('DD/MM/YYYY') : "---"},${i.pago ? "Sim dia " + moment(i.pago).format('DD/MM/YYYY').toString() : "Não"},`

            for (const j of this.state.servicoslist) {
                if ([2, 17].includes(j.id)) continue

                const servicoEncontrado = i.servicos.find(x => x.servico == j.id);

                if (servicoEncontrado) {
                    const valor = servicoEncontrado.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

                    const showSymbol = ![1, 2, 17].includes(j.id);

                    if (showSymbol) {
                        const symbol = this.getSymbolForService(j);
                        csv += `"${valor} ${symbol ? `(${symbol})` : ''}",`;
                    } else {
                        csv += `"${valor}",`;
                    }
                } else {
                    csv += `"---",`;
                }
            }

            csv += `"${i.servicos.find(x => x.servico == 17) ? i.servicos.find(x => x.servico == 17).valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '---'}",`
            csv += `${i.perc_taxa_administracao || 0}%,`
            csv += `"${i.servicos.find(x => x.servico == 2) ? i.servicos.find(x => x.servico == 2).valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '---'}",`
            csv += `${this.convertMesAno(i.mes_ano)},`
            csv += "\n"
        }

        csv = csv.slice(0, csv.length - 1)

        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'planilha.csv';
        hiddenElement.click();
    }

    showMultipleServices(e, servicoInfo) {
        let filterd = e.servicos.filter(x => x.servico == servicoInfo.id)

        const showSymbol = ![1, 2, 17].includes(servicoInfo.id);
        const symbol = showSymbol ? this.getSymbolForService(servicoInfo) : '';

        return filterd.length > 0 ? (
            <td>
                {
                    filterd.map((j, index) => (
                        <div key={index} style={{
                            margin: '2px 0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                        }}>
                            {showSymbol && symbol && (
                                <span style={{
                                    backgroundColor: this.getColorForSymbol(symbol),
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '10px',
                                    fontWeight: 'bold'
                                }}>
                                    {symbol}
                                </span>
                            )}
                            <span>
                                {j.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </span>
                        </div>
                    ))
                }
            </td>
        ) : <td>---</td>;
    }

    sumColumn(id) {
        let s = 0;

        for (const i of this.state.dados) {
            let servico = i.servicos.filter(x => x.servico == id)

            for (const j of servico) {
                s += j.valor
            }
        }

        return s;
    }

    sumTaxa() {
        let total = 0;

        for (const i of this.state.dados) {
            const servicoTaxaAdm = i.servicos.find(x => x.servico == 17);

            if (servicoTaxaAdm) {
                total += parseFloat(servicoTaxaAdm.valor);
            }
        }

        return total;
    }

    render() {
        return <>
            <style type="text/css" media="print">
                @page {'{ size: landscape; }'}

                table, td, tr, th {'{font-size: 9px !important}'}
            </style>

            <div>
                <div>
                    <button
                        className='tohidden btn__primary button'
                        onClick={() => {
                            let link = jwt.sign({
                                pesquisa: {
                                    data_fim: this.state.dataFim,
                                    data_inicio: this.state.dataInicio,
                                    servicos: this.state.servicos,
                                    imobiliaria_id: this.state.dados_login.imobiliaria_id
                                }
                            }, 'PRINTER')
                            window.open("/freedom/relatoriorepassespdf/" + link, "_blank")
                        }}
                        disabled={this.state.loading ? true : false}
                    >
                        Imprimir relatório
                    </button>
                    <button className='tohidden btn__primary button ml-2' onClick={this.genCSV}>Gerar CSV</button>

                    <p className="relatorio-title mt-4">Relatório de repasses</p>

                    <div className="mt-2 mb-3" style={{ fontSize: '12px' }}>
                        <strong>Legenda de Destinação de Valores:</strong>
                        <span style={{
                            backgroundColor: '#28a745',
                            color: 'white',
                            borderRadius: '50%',
                            width: '20px',
                            height: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            marginLeft: '10px',
                            marginRight: '3px'
                        }}>P</span> Proprietário
                        <span style={{
                            backgroundColor: '#007bff',
                            color: 'white',
                            borderRadius: '50%',
                            width: '20px',
                            height: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            marginLeft: '10px',
                            marginRight: '3px'
                        }}>I</span> Imobiliária
                        <span style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            borderRadius: '50%',
                            width: '20px',
                            height: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            marginLeft: '10px',
                            marginRight: '3px'
                        }}>L</span> Locatário
                    </div>
                </div>
                <div className='table mt-4'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>
                                    <div class="thead__item">
                                        <label># Contrato</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Nome Locatário</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Ativo</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Valor boleto</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Vencimento boleto</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Boleto Pago</label>
                                    </div>
                                </th>

                                {
                                    this.state.servicoslist.map(e => (
                                        [2, 17].includes(e.id) ? (null) : (
                                            <th key={e.id}>
                                                <div class="thead__item">
                                                    <label>{e.nome}</label>
                                                </div>
                                            </th>
                                        )
                                    ))
                                }
                                <th>
                                    <div class="thead__item">
                                        <label>Taxa de Administração</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Taxa contrato</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Repasse de aluguel</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Data repasse</label>
                                    </div>
                                </th>
                                <th>
                                    <div class="thead__item">
                                        <label>Competência</label>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.loading || this.state.dados.length === 0 ? (
                                    <tr><th className='text-center' colSpan={13}>{this.state.mensagem}</th></tr>
                                ) : (
                                    this.state.dados.map((e, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td>{e.contrato_id}</td>
                                            <td>{this.formatarLocatarios(e.locatarios)}</td>
                                            <td>{e.ativo == 1 ? "Sim" : "Não"}</td>
                                            <td>{e.boleto_valor ? parseFloat(e.boleto_valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : "---"}</td>
                                            <td>{e.boleto_data_vencimento ? moment(e.boleto_data_vencimento).format('DD/MM/YYYY') : "---"}</td>
                                            <td>{e.pago ? "Sim, dia " + moment(e.pago).format('DD/MM/YYYY').toString() : "Não"}</td>
                                            {
                                                this.state.servicoslist.map(i => (
                                                    [2, 17].includes(i.id) ? (null) : (
                                                        this.showMultipleServices(e, i)
                                                    )
                                                ))
                                            }

                                            <td>
                                                {e.servicos.find(x => x.servico === 17)
                                                    ? (() => {
                                                        const servico = e.servicos.find(x => x.servico === 17);
                                                        const valor = parseFloat(servico.valor);
                                                        const percTaxa = e.perc_taxa_administracao ? parseFloat(e.perc_taxa_administracao) : 0;
                                                        return percTaxa > 0
                                                            ? (valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                                            : "---";
                                                    })()
                                                    : "---"}
                                            </td>

                                            <td>{e.perc_taxa_administracao || 0}%</td>
                                            <td>{e.servicos.find(x => x.servico == 2) ? parseFloat(e.servicos.find(x => x.servico == 2).valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : "---"}</td>
                                            <td>{e.payment_date ? moment(e.payment_date).format('DD/MM/YYYY') : '---'}</td>
                                            <td>{this.convertMesAno(e.mes_ano)}</td>
                                        </tr>
                                    ))
                                )
                            }
                        </tbody>
                        {
                            this.state.loading || this.state.dados.length > 0 ? (
                                <tfoot>
                                    <tr>
                                        <td><strong>Total</strong></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>

                                        {
                                            this.state.servicoslist.map(i => (
                                                [2, 17].includes(i.id) ? (null) : (
                                                    <td key={i.id}>
                                                        <strong>{parseFloat(this.sumColumn(i.id)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong>
                                                    </td>
                                                )
                                            ))
                                        }

                                        <td>
                                            <strong>{parseFloat(this.sumTaxa()).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong>
                                        </td>
                                        <td></td>
                                        <td>
                                            <strong>{parseFloat(this.sumColumn(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            ) : null
                        }
                    </table>
                </div>
            </div>
        </>
    }
}

export default ImprimirRelatorioRepassePage
